import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { Period, PeriodByDate } from '../models/period';

/**
 * <p>
 * API endpoints that cover all resource period related CRUD calls
 */
export const periodApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    currentPeriod: builder.query<PaginationResponse<Period>, void>({
      query: () => ({
        url: encodeURI(`/indirect/period/search?page=0&size=12&sortKey=date&sortDirection=DESC`),
        method: 'GET',
      }),
      providesTags: ['Periods'],
    }),
    periods: builder.query<PaginationResponse<Period>, number>({
      query: (size: number) => ({
        url: encodeURI(`/indirect/period/search?size=${size}&sortDirection=DESC`),
      }),
      providesTags: ['Periods'],
    }),
    periodsByDate: builder.query<PeriodByDate[], string>({
      query: (date: string) => ({
        url: encodeURI(`/indirect/period/byDate?period=${date}`),
      }),
      providesTags: ['Periods'],
    }),
    closePeriod: builder.mutation<void, string>({
      query: (period: string) => ({
        url: encodeURI(`/indirect/period/close?period=${period}`),
        method: 'POST',
      }),
      invalidatesTags: ['Periods'],
    }),
  }),
});

export const { useCurrentPeriodQuery, usePeriodsQuery, usePeriodsByDateQuery, useClosePeriodMutation } = periodApi;
